<template>
  <div class="packages-card" :style="{marginBottom: mb}">
    <button class="reBuy" v-if="buyable" @click="openModal('buy_packages')">
      <img src="../../../assets/images/icons/refresh.svg" alt="">
      <span>Купить пакет</span>
    </button>
    <div class="title" v-if="title">{{ title }}</div>
    <p class="desc">Осталось <strong>{{ lastHours }} часов</strong> из {{ hours }}</p>
    <div class="end" v-if="end">Заканчивается {{ end }}</div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'

export default {
  name: 'packages-card',
  props: {
    title: String,
    date: String,
    lastHours: [String, Number],
    hours: [String, Number],
    buyable: Boolean,
    end: String,
    mb: String
  },
  methods: mapMutations(['openModal'])
}
</script>

<style scoped lang="scss">
.packages-card {
  position: relative;
  padding: 10px;
  border: 1px solid #DBBFA7;
  border-radius: 10px;
  background-color: #FFFFFF;
}

.title {
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
  color: #383838;
  margin-bottom: 5px;
}

.date,
.end {
  font-size: 14px;
  line-height: 1.71;
  color: #808080;
  margin-bottom: 8px;
}

.desc {
  font-size: 16px;
  line-height: 1.5;
  color: #383838;
}

.reBuy {
  padding: 10px;
  display: flex;
  align-items: center;
  z-index: 2;
  left: calc(100% - 30px);
  top: -10px;
  position: absolute;
  width: 40px;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #B9765B;
  border-radius: 5px;
  transition: 300ms width ease;
  overflow: hidden;

  span {
    margin-left: 10px;
    display: block;
    min-width: 105px;
    font-size: 16px;
    line-height: 1.5;
    color: #B9765B;
  }

  &:hover {
    width: 160px;
  }
}
</style>
